import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="xmpproperty" id="xmpproperty"></a>
    <h1 {...{
      "id": "xmpproperty"
    }}>{`XMPProperty`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.2.0  `}</p>
    <a name="new-xmpproperty-new" id="new-xmpproperty-new"></a>
    <h2 {...{
      "id": "xmpproperty-1"
    }}>{`XMPProperty()`}</h2>
    <p>{`This object is returned by various property accessor functions of the `}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{`,
such as `}<a parentName="p" {...{
        "href": "./XMPMeta.md#getpropertyschemans-propname-valuetype"
      }}>{`xmpmetaobj.getProperty`}</a>{`. The read-only properties describe a metadata property.`}</p>
    <a name="xmpproperty-locale" id="xmpproperty-locale"></a>
    <h2 {...{
      "id": "locale--string"
    }}>{`locale : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The language of the property value. This value is set by calls to getLocalizedText(),which assigns the language of the selected alternative text item,if an appropriate item is found.`}</p>
    <a name="xmpproperty-namespace" id="xmpproperty-namespace"></a>
    <h2 {...{
      "id": "namespace--string"
    }}>{`namespace : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The namespace of the property; See `}<a parentName="p" {...{
        "href": "./XMPConst.md#schema-namespace-string-constants"
      }}>{`Schema namespace string constants`}</a>{`.Typically used when browsing metadata with an `}<a parentName="p" {...{
        "href": "./XMPIterator.md"
      }}>{`XMPIterator object`}</a>{`.`}</p>
    <a name="xmpproperty-options" id="xmpproperty-options"></a>
    <h2 {...{
      "id": "options--number"
    }}>{`options : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
A constant that describes the property type, 0 for a simple property.`}<br></br>{`XMPConst.PROP_IS_ARRAY - The property is an array (of type alt, bag, or seq).`}<br></br>{`XMPConst.PROP_IS_STRUCT - The property is a structure with nested fields.`}<br></br></p>
    <a name="xmpproperty-path" id="xmpproperty-path"></a>
    <h2 {...{
      "id": "path--number"
    }}>{`path : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The property path, including the property name.For a simple property, the entire path is the property name.`}</p>
    <a name="xmpproperty-value" id="xmpproperty-value"></a>
    <h2 {...{
      "id": "value--string--number--boolean--xmpdatetime"
    }}>{`value : `}<inlineCode parentName="h2">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`number`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`boolean`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`XMPDateTime`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The value of the property, if any.Arrays and non-leaf levels of structures do not have values.`}</p>
    <a name="xmpproperty-tostring" id="xmpproperty-tostring"></a>
    <h2 {...{
      "id": "tostring"
    }}>{`toString()`}</h2>
    <p>{`To get the Property Value as String`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - The value of the property as a string.  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      